import dayjs from "dayjs";

export function getValueForDashBoard(metricName: string, data: any) {
  let dataOfMetricToExtract;

  data
    ?.filter(
      (item: any) => item?.Metrics?.toLowerCase() === metricName?.toLowerCase()
    )
    // eslint-disable-next-line
    ?.map((item: any) => {
      dataOfMetricToExtract = item;
    });

  return dataOfMetricToExtract;
}

export function checkIfMetricsExist(metricName: string, data: any) {
  let flag = false;

  // eslint-disable-next-line
  data
    // eslint-disable-next-line
    ?.filter(
      (item: any) => item?.Metrics?.toLowerCase() === metricName?.toLowerCase()
    )
    // eslint-disable-next-line
    ?.map((_: unknown) => {
      flag = true;
    });

  return flag;
}

export function calculateQuarterStartOfDate(quarter: any, year: any) {
  if (quarter < 1 || quarter > 4) {
    throw new Error("Quarter must be between 1 and 4");
  }

  // Calculate the start month of the quarter
  const startMonth = (quarter - 1) * 3;

  // Get the first date of the quarter
  const quarterStartDate = dayjs(
    `${year}-${String(startMonth + 1).padStart(2, "0")}-01`
  );

  // return the first day of the quarter
  return quarterStartDate.format("YYYY-MM-DD");
}

export function getLastDateOfQuarter(date: any) {
  const currentQuarter = dayjs(date).quarter(); // Get the current quarter (1-4)
  const lastMonthOfQuarter = currentQuarter * 3; // Last month of the quarter
  return dayjs(date)
    .month(lastMonthOfQuarter - 1)
    .endOf("month"); // Last date of the last month
}

export function calculateStartAndEndDates(
  selectedPriode: any,
  selectedInterval?: any
) {
  let dateChosenByUser = selectedPriode;
  let endDate = "";
  let startDate = "";
  let originalEndDateOfPeriod = "";
  let originalStartDateOfPeriod = "";

  if (selectedInterval === "Quarter") {
    const quarter = dateChosenByUser.split(" ")[0].charAt(1); // getting the quarter number from string like this Q1 2023
    const year = dateChosenByUser.split(" ")[1]; // getting the year from the same  string
    dateChosenByUser = calculateQuarterStartOfDate(quarter, year);
    // The original end date of the period
    originalEndDateOfPeriod = dayjs(
      getLastDateOfQuarter(dateChosenByUser)
    ).format("YYYY-MM-DD");
    originalStartDateOfPeriod = dayjs(dateChosenByUser).format("YYYY-MM-DD");
  } else {
    // The original end date of the period
    originalEndDateOfPeriod = dayjs(dateChosenByUser)
      .endOf("month")
      .format("YYYY-MM-DD");
    originalStartDateOfPeriod = dayjs(dateChosenByUser)
      .startOf("month")
      .format("YYYY-MM-DD");
  }

  startDate = originalStartDateOfPeriod;
  endDate = originalEndDateOfPeriod;

  return {
    startDate: startDate,
    endDate: endDate,
  };
}

export function getSelectedTimePeriod(selectedPriode: any) {
  let startDate = null,
    endDate = null;
  let periodType = "";

  switch (selectedPriode) {
    case "MTD":
      startDate = dayjs().startOf("month").format("YYYY-MM-DD");
      endDate = dayjs().format("YYYY-MM-DD");
      break;
    case "Yesterday":
      startDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
      endDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
      break;
    case "Last 7 Days":
      startDate = dayjs().subtract(8, "day").format("YYYY-MM-DD");
      endDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
      break;
    case "Last Month":
      startDate = dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      endDate = dayjs()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");
      break;
    case "YTD":
      startDate = dayjs().startOf("year").format("YYYY-MM-DD");
      endDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
      break;
    case "Last 30 Days":
      startDate = dayjs().subtract(30, "day").format("YYYY-MM-DD");
      endDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
      break;
    case "Last 6 Week":
      startDate = dayjs().subtract(6, "week").format("YYYY-MM-DD");
      endDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
      break;
    case "Last 12 Month Full":
      periodType = "Full";
      break;
    case "Last 12 Month Proportional":
      periodType = "Proportional";
      break;
    default:
      break;
  }

  return {
    startDate: startDate,
    endDate: endDate,
    periodType: periodType,
  };
}

export function roundedNumberHighLevel(strNumber: any) {
  const num = parseFloat(strNumber); // Convert string to number
  if (isNaN(num) || strNumber === null) {
    return "null";
  }
  if (num <= 0) {
    return "0";
  }
  let rounded = Math.round(num).toLocaleString(); // Round to nearest integer
  return rounded.toString(); // Convert back to string
}

export function roundStringNumberToInt(
  strNumber: any,
  rounded2figures?: boolean
) {
  const num = parseFloat(strNumber); // Convert string to number
  if (isNaN(num) || strNumber === null) {
    return "null";
  }

  let rounded;
  if (rounded2figures) {
    rounded = Number(num.toFixed(1)); // Round the number to 1 decimal place and remove trailing ".0" if present
  } else {
    rounded = Math.round(num).toLocaleString(); // Round to nearest integer
  }

  return rounded.toString(); // Convert back to string
}
